import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { headersBase, headersType } from "../../../utils/constants/headersForApi";

export const adminNewsApi = createApi({
  reducerPath: "adminNews",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getNews: builder.query({
      query: ({ page: { startRow, endRow } }) => ({
        url: "/admin/news/list",
        method: "POST",
        headers: headersType(),
        body: { startRow, endRow },
      }),
    }),
    getNewsDetail: builder.query({
      query: (id) => ({
        url: "/admin/news/" + id,
        method: "GET",
        headers: headersBase(),
      }),
    }),
  }),
});

export const { useGetNewsQuery, useGetNewsDetailQuery } = adminNewsApi;
